import { h } from "preact";

function TimerIcon(props) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props.color || 'currentColor'}
    stroke-width={props.strokeWidth || 1}
    stroke-linecap="round"
    stroke-linejoin="round"
    className={props.className || 'feather'}
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

export default TimerIcon